import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, ScrollText } from "lucide-react";

const ACTION_STYLE = {
  suspend: "bg-red-50 text-red-600", cancel: "bg-red-50 text-red-600",
  reactivate: "bg-emerald-50 text-emerald-600", refund: "bg-amber-50 text-amber-700",
  comp: "bg-cobalt-light text-cobalt", extend: "bg-cobalt-light text-cobalt",
  grant: "bg-emerald-50 text-emerald-600", lifetime: "bg-purple-50 text-purple-700",
  grandfather: "bg-amber-50 text-amber-700",
};

export const BillingAuditList = ({ items, compact = false }) => (
  <div className="space-y-2" data-testid="billing-audit-list">
    {items.map((e) => (
      <div key={e.audit_id} className="bg-white rounded-2xl border border-slate-100 p-4" data-testid={`billing-audit-${e.audit_id}`}>
        <div className="flex items-center justify-between gap-2 flex-wrap">
          <span className={`text-[11px] font-semibold px-2.5 py-1 rounded-full ${ACTION_STYLE[e.action] || "bg-slate-100 text-slate-600"}`}>{e.action_label || e.action}</span>
          <span className="text-xs text-slate-400">{new Date(e.occurred_at).toLocaleString()}</span>
        </div>
        <div className="mt-2 text-sm text-navy font-medium">“{e.reason}”</div>
        <div className="mt-1 text-xs text-slate-500">
          By <span className="font-medium text-navy">{e.admin_name || e.admin_email}</span>
          {!compact && <> → Attorney <span className="font-medium text-navy">{e.attorney_name || e.attorney_email}</span></>}
          {e.details && Object.keys(e.details).length > 0 && (
            <span className="text-slate-400"> · {Object.entries(e.details).map(([k, v]) => `${k}: ${String(v).slice(0, 24)}`).join(" · ")}</span>
          )}
        </div>
      </div>
    ))}
  </div>
);

// Global, append-only Super Admin billing audit log.
export default function AdminBillingAudit() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/billing/audit?limit=200").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (items === null) return <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 text-cobalt animate-spin" /></div>;
  return (
    <div className="space-y-4" data-testid="admin-billing-audit">
      <div className="bg-white rounded-2xl border border-slate-100 p-4 flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-cobalt-light flex items-center justify-center shrink-0"><ScrollText className="w-5 h-5 text-cobalt" /></div>
        <div>
          <div className="font-heading font-semibold text-navy">Billing Audit Log</div>
          <div className="text-xs text-slate-500">Permanent record of every Super Admin billing action — who acted, the reason, the timestamp, and the affected attorney. Entries can never be edited or deleted.</div>
        </div>
      </div>
      {items.length === 0
        ? <div className="bg-white rounded-2xl border border-slate-100 p-8 text-center text-slate-500 text-sm">No billing actions recorded yet.</div>
        : <BillingAuditList items={items} />}
    </div>
  );
}
